export const isCNPJ = (value: string): boolean => {
  if (!value) return false;
  const cnpj = value.replace(/\D/g, "");
  if (cnpj.length !== 14) return false;
  if (/^(\d)\1{13}$/.test(cnpj)) return false;

  const calcCheckDigit = (cnpj: string, length: number): number => {
    const weights =
      length === 12
        ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
        : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

    const sum = cnpj
      .slice(0, length)
      .split("")
      .reduce((acc, curr, i) => acc + Number(curr) * weights[i], 0);

    const remainder = sum % 11;
    return remainder < 2 ? 0 : 11 - remainder;
  };

  const digit1 = calcCheckDigit(cnpj, 12);
  const digit2 = calcCheckDigit(cnpj, 13);

  return digit1 === Number(cnpj[12]) && digit2 === Number(cnpj[13]);
};
